import { render, staticRenderFns } from "./MyTournaments.vue?vue&type=template&id=1ecec39d&"
import script from "./MyTournaments.vue?vue&type=script&lang=js&"
export * from "./MyTournaments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports